module.exports = __webpack_public_path__ + "static/media/ProductNew1.9843d106.webp";